module.exports = __webpack_public_path__ + "img/1532256614.b589362b.jpg";